// extracted by mini-css-extract-plugin
export default {"custom-tooltip":"Tooltip_custom-tooltip__8lJDH","custom-tooltip-target":"Tooltip_custom-tooltip-target__9OYoU"};